import React from 'react'

const Hero = () => {
  return (
    <section className="hero-bg pt-20 pb-16 text-center relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="mb-6">
            <span className="premium-badge">✨ Your Vision, Our Aura</span>
          </div>
          <h1 className="text-4xl md:text-7xl font-extrabold leading-tight tracking-tight text-white mb-6">
            Crafting Unforgettable
            <span className="gradient-text block mt-2">Event Experiences</span>
          </h1>
          <p className="text-lg md:text-2xl max-w-4xl mx-auto mb-10 text-white/90 leading-relaxed">
            From intimate celebrations to grand corporate gatherings, <strong className="text-white">AuraSquare Events</strong> - Chennai's best & premium event management company - transforms ordinary moments into extraordinary memories. We specialize in complete event management, stunning decorations, cutting-edge technology, and unforgettable entertainment for weddings, birthdays, corporate events, college festivals across Tamil Nadu.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center flex-wrap">
            <a href="#services" className="premium-btn text-lg px-8 py-4 inline-flex items-center gap-2">
              <i className="fas fa-star"></i>
              <span>Explore Our Services</span>
            </a>
            <a
              href="https://wa.me/919444848616"
              className="premium-btn text-lg px-8 py-4 inline-flex items-center gap-2"
              style={{ background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)" }}
            >
              <i className="fab fa-whatsapp"></i>
              <span>Plan Your Event Now</span>
            </a>
          </div>

          {/* Stats Section - Hidden for now */}
          {false && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">500+</div>
              <div className="text-white/80 text-sm md:text-base">Events Completed</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">100+</div>
              <div className="text-white/80 text-sm md:text-base">Corporate Clients</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">50+</div>
              <div className="text-white/80 text-sm md:text-base">Entertainment Options</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">100%</div>
              <div className="text-white/80 text-sm md:text-base">Tamil Nadu Coverage</div>
            </div>
          </div>
          )}
        </div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 left-10 text-white/20 text-4xl float-animation" style={{ animationDelay: '0.5s' }} aria-hidden="true">
        ✨
      </div>
      <div className="absolute top-40 right-20 text-white/20 text-3xl float-animation" style={{ animationDelay: '1s' }} aria-hidden="true">
        🎊
      </div>
      <div className="absolute bottom-20 left-20 text-white/20 text-5xl float-animation" style={{ animationDelay: '1.5s' }} aria-hidden="true">
        🎉
      </div>
      <div className="absolute bottom-40 right-10 text-white/20 text-4xl float-animation" style={{ animationDelay: '2s' }} aria-hidden="true">
        ⭐
      </div>
    </section>
  )
}

export default Hero
